import { ServerFetch } from '../main-model'

export default class PromotionListModel extends ServerFetch {
    getPromotionListBy = (data) => this.authFetch({
        url: 'promotion-list/getPromotionListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}